import Http from 'common/services/Http';
import { Paged } from 'api/common/types/Page';
import { PrivacyDriverDto } from './models/PrivacyDriverDto';
import { PrivacyVehicleDto } from './models/PrivacyVehicleDto';
import { PrivacyHistoryDto } from './models/PrivacyHistoryDto';
import { DeletionHistoryDto } from './models/DeletionHistoryDto';
import { TogglePrivacyCommand } from './models/TogglePrivacyCommand';
import { SaveScheduleCommand } from './models/SaveScheduleCommand';
import { ScheduleSlotDto } from './models/ScheduleSlotDto';
import { PrivacySearchCriteria } from './models/PrivacySearchCriteria';

class PrivacyService {

    public getDrivers(criteria?: PrivacySearchCriteria) {
        return Http.get<Paged<PrivacyDriverDto>>('privacy/drivers', criteria);
    }

    public getVehicles(criteria?: PrivacySearchCriteria) {
        return Http.get<Paged<PrivacyVehicleDto>>('privacy/vehicles', criteria);
    }

    public getMyVehicles(criteria?: PrivacySearchCriteria) {
        return Http.get<Paged<PrivacyVehicleDto>>('privacy/my/vehicles', criteria);
    }

    public getDriversHistory(criteria?: PrivacySearchCriteria) {
        return Http.get<Paged<PrivacyHistoryDto>>('privacy/drivers/history', criteria);
    }

    public getVehiclesHistory(criteria?: PrivacySearchCriteria) {
        return Http.get<Paged<PrivacyHistoryDto>>('privacy/vehicles/history', criteria);
    }

    public getDeletionHistory(criteria?: PrivacySearchCriteria) {
        return Http.get<Paged<DeletionHistoryDto>>('privacy/delete-data/history', criteria);
    }

    public togglePrivacy(command: TogglePrivacyCommand) {
        if (command.entityType === 'driver') {
            return Http.put<void>('privacy/drivers/toggle', {
                driverId: command.entityId,
                privacyEnabled: command.enabled,
            });
        }
        return Http.put<void>('privacy/vehicles/toggle', {
            vehicleId: command.entityId,
            privacyEnabled: command.enabled,
        });
    }

    public toggleMyPrivacy(vehicleId: string, enabled: boolean) {
        return Http.put<void>('privacy/my/vehicles/toggle', {
            vehicleId,
            privacyEnabled: enabled,
        });
    }

    public saveSchedule(command: SaveScheduleCommand) {
        if (command.entityType === 'driver') {
            return Http.put<void>('privacy/drivers/schedule', {
                driverId: command.entityId,
                slots: command.slots,
            });
        }
        return Http.put<void>('privacy/vehicles/schedule', {
            vehicleId: command.entityId,
            slots: command.slots,
        });
    }

    public getSchedule(entityId: string, entityType: 'driver' | 'vehicle') {
        const route = entityType === 'driver' ? `privacy/drivers/${entityId}/schedule` : `privacy/vehicles/${entityId}/schedule`;
        return Http.get<ScheduleSlotDto[]>(route);
    }

    public deleteData(entityId: string, entityName: string, entityType: 'driver' | 'vehicle', startDate: string | null, endDate: string | null) {
        if (entityType === 'driver') {
            return Http.post<void>('privacy/delete-data/driver', {
                driverId: entityId,
                driverName: entityName,
                dateRangeStart: startDate,
                dateRangeEnd: endDate,
            });
        }
        return Http.post<void>('privacy/delete-data/vehicle', {
            vehicleId: entityId,
            vehicleName: entityName,
            dateRangeStart: startDate,
            dateRangeEnd: endDate,
        });
    }
}

export default new PrivacyService();
